import requestModule from '@/application/libs/requestModule'
import util from  '@/application/libs/util'
import { t } from 'i18next'

const getCDFILIAL = () => util.getFilterInSession().CDFILIAL;
const getCDSERVFILI = () => util.getFilterInSession().CDSERVFILI;
const getIDTIPORESTRICAO = () => util.getFilterInSession().TPCONTRATO;
const getIDUTRPADCA = () => util.getFilterInSession().IDUTRPADCA;
const getCDNVPRATO = () => util.getPlateNivel();

export default {

    /**
     * Return frequency
     * of plate per date period.
     * 
     * @returns {Promise}
     */
    getPlateFrequencyGridData(NRVIGENCIA){
        return requestModule.postRequest('getData', {
            FROM: "FREQUENCIAPRATO",
            PARAMS: {
                NRVIGENCIA: NRVIGENCIA,
                CDSERVFILI: getCDSERVFILI()
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    /**
     * Return frequency
     * of plate's groups products per date period.
     * 
     * @returns {Promise}
     */
    getPlateGroupProductFrequencyGridData(NRVIGENCIA){
        return requestModule.postRequest('getData', {
            FROM: "FREQUENCIAGRUPOPRATOPRODUTO",
            PARAMS: {
                CDSERVFILI: getCDSERVFILI(),
                NRVIGENCIA: NRVIGENCIA,
                IDTIPORESTRICAO: util.getFilterInSession().TPCONTRATO
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    /**
     * @returns {Promise}
     */
    getPlateWeekdayUtilization(NRVIGENCIA){
        return requestModule.postRequest('getData', {
            FROM: "UTILIZACAOPRATOSEMANA",
            PARAMS: {
                IDTIPORESTRICAO: getIDTIPORESTRICAO(),
                CDSERVFILI: getCDSERVFILI(),
                NRVIGENCIA: NRVIGENCIA
            }
        }).then(response=>response.dataset && response.dataset.data);
    },


    getValidity(FROM) {
        return requestModule.postRequest('getData', {
          FROM,
          PARAMS: {
            CDFILIAL: getCDFILIAL(),
            DTMESCARD: util.getFilterInSession().DTMESCARD,
            IDTIPORESTRICAO: getIDTIPORESTRICAO()
          }
        }).then(response => response.dataset && response.dataset.data);
      },

    getProductGroupPlateRestrictions(NRVIGENCIA){
        return requestModule.postRequest('getData', {
            FROM: "PRODUTOGRUPOPRATORESTRICACAO",
            PARAMS: {
                IDTIPORESTRICAO:getIDTIPORESTRICAO(),
                CDSERVFILI: getCDSERVFILI(),
                NRVIGENCIA: NRVIGENCIA
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getPlateGroupFrequencyGridData(NRVIGENCIA){
        return requestModule.postRequest('getData', {
            FROM: "FREQUENCIAGRUPO",
            PARAMS: {
                NRVIGENCIA: NRVIGENCIA,
                CDSERVFILI: getCDSERVFILI(),
                CDFILIAL: getCDFILIAL(),
                IDTIPORESTRICAO: getIDTIPORESTRICAO()
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    
    getRulesToBeFlexibleInScenarioPostProcessing(){
        return requestModule.postRequest('getData', {
            FROM: "RULESPOSPROCESSING",
            PARAMS: {}
        }).then(response=>response.dataset && response.dataset.data.sort((a, b) => a.NRORDEMREGRA - b.NRORDEMREGRA));
    },

    getServicePlateGroup(NRVIGENCIA) {
        return requestModule.postRequest('getData', {
            FROM: "GRUPOPRATOSERV_AUTOCOMPLETE",
            PARAMS: {
                NRVIGENCIA: NRVIGENCIA,
                CDSERVFILI: getCDSERVFILI(),
                CDFILIAL: getCDFILIAL(),
                IDTIPORESTRICAO: getIDTIPORESTRICAO(),
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getPlateGroup() {
        return requestModule.postRequest('getData', {
            FROM: "GRUPOPRATO_AUTOCOMPLETE",
            PARAMS: {
                CDSERVFILI: getCDSERVFILI(),
                CDFILIAL: getCDFILIAL(),
                IDTIPORESTRICAO: getIDTIPORESTRICAO(),
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getPlates(userQuery = null, NRVIGENCIA, maxResults = 50) {
        return requestModule.postRequest('getData', {
            FROM: "PRATO_NAO_PARAMETRIZADO_FREQ",
            PARAMS: {
                CDFILIAL: getCDFILIAL(),
                PRATO: userQuery,
                NRVIGENCIA: NRVIGENCIA,
                IDUTRPADCA: getIDUTRPADCA(),
                CDSERVFILI: getCDSERVFILI(),
                CDNVPRATO: getCDNVPRATO(),
                MAX_RESULTS: maxResults 
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getGruoupForNewWeekdayUsage(NRVIGENCIA, userQuery = null, maxResults = 50) {
        return requestModule.postRequest('getData', {
            FROM: "GRUPO_NAO_PARAMETRIZADO_UTILIZACAO_SEMANA",
            PARAMS: {
                CDFILIAL: getCDFILIAL(),
                CDSERVFILI: getCDSERVFILI(),
                IDTIPORESTRICAO: getIDTIPORESTRICAO(),
                GRUPO: userQuery,
                NRVIGENCIA: NRVIGENCIA,
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getProducts(userQuery = null, maxResults = 50) {
        return requestModule.postRequest('getData', {
            FROM: "PRODUTO_AUTOCOMPLETE",
            PARAMS: {
                PRODUTO: userQuery,
                MAX_RESULTS: maxResults 
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getValidityObservations() {
        return requestModule.postRequest('getData', {
            FROM: "DESCOBSFILIAL",
            PARAMS: {}
        }).then(response=>response.dataset && response.dataset.data);
    },

    saveChangedData(changedData, dataSourceName){
        return requestModule.postRequest('updateData', {
            FROM: dataSourceName,
            PARAMS: changedData,
        });
    },
    
    saveIdflexivelRow(toSaveData){
        return requestModule.postRequest('updateData', {
            FROM:'RULES_TO_BE_FLEXIBLE',
            PARAMS:{
                IDFLEXIVEL: toSaveData.IDFLEXIVEL,
                NROTMREGRAFLEX: toSaveData.NROTMREGRAFLEX
            }
        });
    },
    
    updateOrderRule(data){
        return requestModule.postRequest('updateData', {
            FROM:'RULES_UPDATE_ORDER',
            PARAMS:{
                NROTMREGRAFLEX_ORI: data.NROTMREGRAFLEX_ORI,
                NROTMREGRAFLEX_DEST: data.NROTMREGRAFLEX_DEST
            }
        });
    },

    updRestoreFlexibleRules(){
        return requestModule.postRequest('updateData', {
            FROM:'RULES_UPDATE_RESTORE',
            PARAMS:{
                IDFLEXIVEL: "N"
            }
        });
    },
    
    insertData(changedData, dataSourceName){
        return new Promise((resolve, reject) => {
            requestModule.postRequest('insertData', {
                FROM: dataSourceName,
                PARAMS: changedData,
            }).then(response => {
                if(!response.error){
                    resolve(response);
                } else {
                    
                   response.error = this.translateBackendMessage(response);
                   
                   throw response;
                }
            }).catch(e => {
                if(e.errorCode !== 0){
                    reject(e);
                } else {
                    reject({});
                }
            })
        });
    },
    deleteData(changedData, dataSourceName){
        return new Promise((resolve, reject) => {
            requestModule.postRequest('deleteData', {
                FROM: dataSourceName,
                PARAMS: changedData,
            }).then(response => {
                if(!response.error){
                    resolve(response);
                } else {
                    response.error = this.translateBackendMessage(response);
                    throw response;
                }
            }).catch(e => {
                if(e.errorCode !== 0){
                    reject(e);
                } else {
                    reject({});
                }
            })
        });
    },
    getFiliaOper(){
        return requestModule.postRequest('getData', {
            FROM: "FILIAL_FILIOPER",
            PARAMS: {
                CDOPERADOR: util.getLocalVar('userData').CDOPERADOR,
                NRORG: util.getLocalVar("userData").NRORG,
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getServico(LISTAFILIAL, MODAL){
        return requestModule.postRequest('getData', {
            FROM: "SERVICE_FILIOPER",
            PARAMS: {
                LISTACDFILIAL: LISTAFILIAL,
                CDFILIAL: getCDFILIAL(),
                CDSERVFILI: MODAL == 'GROUP' ? 'T' : getCDSERVFILI(),
                CDOPERADOR: util.getLocalVar('userData').CDOPERADOR,
                NRORG: util.getLocalVar("userData").NRORG,
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getGroupPrat() {
        return requestModule.postRequest('getData', {
            FROM: "GET_GROUP_PRAT",
            PARAMS: {
                P_IDTIPORESTRICAO: getIDTIPORESTRICAO(),
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getMultiGroupPrat() {
        return requestModule.postRequest('getData', {
            FROM: "GET_MULTI_GROUP_PRAT",
            PARAMS: {
                P_CDFILIAL: getCDFILIAL(),
                P_CDSERVFILI: getCDSERVFILI(),
                P_IDTIPORESTRICAO: getIDTIPORESTRICAO(),
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    updateDataValidity(VALIDITY, TABLENAME){
        return requestModule.postRequest('getData', {
            FROM: "GET_VALIDITY",
            PARAMS: {
                P_NRVIGENCIA: VALIDITY,
                P_CDFILIAL: getCDFILIAL(),
                P_IDTIPORESTRICAO: getIDTIPORESTRICAO(),
                P_TABLENAME: TABLENAME,
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    exportValidityProcedureCaller(EXPORTVALIDITY){
        return requestModule.postRequest('exportValidity', 
            {
                OBJECTEXPORT: EXPORTVALIDITY,
                CDFILIAL: getCDFILIAL(),
                CDSERVFILI: getCDSERVFILI(),
                CDOPERADOR: util.getLocalVar('userData').CDOPERADOR,
                IDTIPORESTRICAO: getIDTIPORESTRICAO(),
                NRORG: util.getLocalVar("userData").NRORG,
            }
        ).then(response=>response.dataset);
    },
    
    
     /**
     * Realiza tradução do retorno mensagem de erro do Backend. Tratativa dos dados realizado pela função formatMsgTradu do DataProvider.php.
     *
     * @param response  (Parâmetro Obrigatório) - Resposta do Backend.
     * OBS.: Quando a mensagem tiver apenas 1 parâmetro o mesmo deve estar declarado no messages.json como {{PARAM}}.
     *       Quando existir mais de um parâmetro os mesmos devem estar cadastrados como {{PARAM_0}} ... {{PARAM_1}}, a numeração se refere ao indice de cada parâmetro.
     */
    translateBackendMessage(response){
        if(response.error.msg_params && Array.isArray(response.error.msg_params)){
                        
            let objParamsMgs = {};
            for (let i =0; i<response.error.msg_params.length; i++){
               
                objParamsMgs['PARAM_'+i] = response.error.msg_params[i];
                
            }
           
            response.error = t(response.error.msg_code, objParamsMgs);
            
        }else if (response.error.msg_params && !Array.isArray(response.error.msg_params)){
            response.error = t(response.error.msg_code, {PARAM: response.error.msg_params});
        }else if(!response.error.msg_params){
            response.error = t(response.error);
        }
        
        return response.error
                    
    }
}